import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33966c44"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center mt-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "fs-lg-3x fs-sm-1 mb-5 text-center" }, " Step into Saving, Explore Deals, Enjoy Rewards! ")
], -1))
const _hoisted_2 = { class: "dashboard-container mt-10" }
const _hoisted_3 = { class: "d-flex flex-column mb-10 min-h-300" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "",
  style: {}
}, [
  /*#__PURE__*/_createElementVNode("strong", { class: "fs-1 content-header" }, "Partners")
], -1))
const _hoisted_5 = { class: "d-flex flex-row flex-wrap mt-5" }
const _hoisted_6 = {
  key: 1,
  class: "d-flex justify-content-center w-100 mt-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderImage = _resolveComponent("HeaderImage")!
  const _component_AgencyCard = _resolveComponent("AgencyCard")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_DrawLoaderCard = _resolveComponent("DrawLoaderCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "d-flex justify-content-center",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleToggleChat && _ctx.handleToggleChat(...args))),
      style: {"cursor":"pointer"}
    }, [
      _createVNode(_component_HeaderImage)
    ]),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.loadingAgency)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.agencies.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.agencies, (agency, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-lg-4 col-md-6 p-2"
                      }, [
                        _createVNode(_component_AgencyCard, {
                          class: "draw-card",
                          agency: agency
                        }, null, 8, ["agency"])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_el_empty, { description: "Active Partner and Affiliates Here Soon" })
                    ]))
              ], 64))
            : (_openBlock(), _createBlock(_component_DrawLoaderCard, {
                key: 1,
                loading: _ctx.loadingAgency,
                showButton: false,
                showTimer: false,
                showTitle: true
              }, null, 8, ["loading"]))
        ])
      ])
    ])
  ]))
}